// Custom không ghi đè fetch của Free Gift nữa - Khách muốn quà add sau khi add sp chính
(function() {
    let obj = window.fetch;
 
    Object.defineProperty(window, "fetch", {
        get() {
            return obj;
        },
        set(val) {
            // Kiểm tra nếu là hàm override của Free Gift thì sẽ bỏ qua và ghi đè code mới
            if (val.toString().includes("updateOriginalFetch")) {
                console.log("SALEPIFY - Update custom code")
                tlFreeGiftOverride()
            } else {
                obj = val;
            }
 
        },
        configurable: true
    });


    function tlFreeGiftOverride() {
        if (!window || !window.Shopify) return;

        const CartEvents = {
            add: "TLFREEGIFT:add",
            update: "TLFREEGIFT:update",
            change: "TLFREEGIFT:change",
            clear: "TLFREEGIFT:clear",
            mutate: "TLFREEGIFT:mutate",
        };

        const ShopifyCartURLs = [
            "/cart/add",
            "/cart/update",
            "/cart/change",
            "/cart/clear",
            "/cart/add.js",
            "/cart/update.js",
            "/cart/change.js",
            "/cart/clear.js",
            "/cart/add.js?upcart=1&opens_cart=maybe"
        ];

        function isShopifyCartURL(url) {
            if(url instanceof URL) url = url.href;
            if(typeof url == "object" && url.url) url = url.url;
            if (!url || url.includes("app=salepify")) return false;
            
            try {
                let path = url.split("/").pop();
                    path = path.split("?").shift();
                return ShopifyCartURLs.includes(`/cart/${path}`);
            } catch (e) {
                console.log("Not a normal URL: ", e)
                return false;
            }
        }
        
        function updateType(url) {
            if (!url || url.includes("app=salepify")) return false;
            if (url.includes("cart/add")) {
                return "add";
            } else if (url.includes("cart/update")) {
                return "update";
            } else if (url.includes("cart/change")) {
                return "change";
            } else if (url.includes("cart/clear")) {
                return "clear";
            } else return false;
        }

        function dispatchEvent(url, detail) {
            if (typeof detail === "string") {
                try {
                    detail = JSON.parse(detail);
                } catch (e) {
                    console.log("Error: ", e)
                }
            }

            const type = updateType(url);
            switch (type) {
                case "add":
                    window.dispatchEvent(new CustomEvent(CartEvents.add, {detail}));
                    break;
                case "update":
                    window.dispatchEvent(new CustomEvent(CartEvents.update, {detail}));
                    break;
                case "clear":
                    window.dispatchEvent(new CustomEvent(CartEvents.clear, {detail}));
                    break;
                case "change":
                    window.dispatchEvent(new CustomEvent(CartEvents.change, {detail}));
                    break;
                default:
                    break;
            }
        }

        function getJsonBodyArgument (bodyArgument) {
            if (!bodyArgument) return {};
            
            let jsonBodyArgument = {}
            if(window.tlFreeGiftOffer.utils.isJson(bodyArgument)) {
                jsonBodyArgument = JSON.parse(bodyArgument);
            }
            else if (typeof(bodyArgument) === "string"){
                const params = new URLSearchParams(bodyArgument);
                const json = Object.fromEntries(params.entries());
                jsonBodyArgument = json;
            }
            return jsonBodyArgument;
        }

        // Override xhr
        function XHROverride() {
            if (!window.XMLHttpRequest) return;

            const originalOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function(method, url, async) {
                if (isShopifyCartURL(url)) {
                    window.tlFreeGiftOffer.cartHasChanged = true;
                    this.addEventListener('readystatechange', async () => {
                        if (this.readyState === 4) {
                            dispatchEvent(url, this.response);
                        }
                    });
                }
                return originalOpen.apply(this, arguments);
            };
        }

        // Handle Shop pay
        async function getOtherPayItemData(originalData, parsedBody) {
            const lineItemData = parsedBody.variables?.input?.lines?.[0];
            const merchandiseId = lineItemData?.merchandiseId;
            const itemId = merchandiseId.split("/").pop();
            const itemDataRes = await window.tlFreeGiftOffer.storefrontApi.getVariantData(itemId);
            const itemData = itemDataRes?.node;

            const sellingPlanAllocation = originalData?.data?.result?.cart?.lines?.edges?.[0]?.node?.sellingPlanAllocation;
            return {
                id: itemId,
                price: parseFloat(itemData.price.amount) * window.tlFreeGiftOffer.currencyRate,
                quantity: lineItemData?.quantity ?? 1,
                productId: itemData.product.id.split("/").pop(),
                selling_plan: !!sellingPlanAllocation
            }
        }

        function hasSpecificCountryCondition(rule) {
            if (rule.advanced_conditions) {
                const advancedCondition = JSON.parse(rule.advanced_conditions);
                if (advancedCondition.specific_country) {
                    return true
                }
            }

            return false;
        }

        async function processOtherPayGiftRules(originalData, parsedBody) {
            const giftLines = [];
            const discounts = [];
            const rules = window.tlFreeGiftOffer.rules;

            const currentItemsInCart = window.tlFreeGiftOffer.itemsInCart;
            const currentRuleIdMapGifts = window.tlFreeGiftOffer.ruleIdMapGifts;
            const ruleIdMapState = window.tlFreeGiftOffer.ruleIdMapState;

            // fake itemsInOtherPay
            const itemsInOtherPayCart = new Map();
            const itemData = await getOtherPayItemData(originalData, parsedBody);
            itemsInOtherPayCart.set(itemData.id, itemData)

            // fake ruleIdMapGiftAddedByApp
            window.tlFreeGiftOffer.itemsInCart = itemsInOtherPayCart;
            window.tlFreeGiftOffer.ruleIdMapGifts = new Map();
            window.tlFreeGiftOffer.ruleIdMapState = new Map();
            
            let shouldPushLocation = false;
            for ( const rule of rules ) {
                if (rule.auto_add_gift) {
                    window.tlFreeGiftOffer.cartHasChanged = true;
                    const { needToAdd, giftsToAdd } = await window.tlFreeGiftOffer.checkRuleCondition(rule);
                    if(needToAdd){
                        for (const item of giftsToAdd) {
                            const giftLine = {
                                merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
                                quantity: item.quantity,
                                attributes: Object.entries(item.properties || {}).map(([key, value]) => ({
                                    key,
                                    value: String(value)
                                }))
                            }
                            giftLines.push(giftLine);
                        }
                        discounts.push(rule.discount_code);
                    }
                }

                if(hasSpecificCountryCondition(rule)) shouldPushLocation = true;
            }

            if (shouldPushLocation) {
                const { country, region } = await this.getIpInfo();
                
                if (!Array.isArray(parsedBody.variables.input.attributes)) {
                    parsedBody.variables.input.attributes = [];
                }
                parsedBody.variables.input.attributes.push({
                    key: window.tlFreeGiftOffer.constants.LOCATION_CART_ATTRIBUTE,
                    value: `${country}-${region}`,
                });
            }

            parsedBody.variables.input.lines.push(...giftLines);
            parsedBody.variables.input.discountCodes = discounts;

            // Restore state before handling OtherPay 
            window.tlFreeGiftOffer.itemsInCart = currentItemsInCart;
            window.tlFreeGiftOffer.ruleIdMapGifts = currentRuleIdMapGifts;
            window.tlFreeGiftOffer.ruleIdMapState = ruleIdMapState;
            return parsedBody;
        }

        // Override fetch
        function detectAddApi(config) {
            let itemId = null;
            let quantity = 1;
            let sellingPlan = null;

            if (config.body instanceof FormData && config.body.getAll("id")) {
                itemId = String(config.body.getAll("id"));
                quantity = Number(config.body.getAll("quantity")) ? Number(config.body.getAll("quantity")) : 1;
                const sellingPlanData = config.body.getAll("selling_plan");
                sellingPlan = sellingPlanData && sellingPlanData[0] ? sellingPlanData[0] : null
            }else {
                const allRequestBody = config.body.split("&");
                if (allRequestBody.length) {
                    allRequestBody.map(param => {
                        if (param) {
                            const paramArray = param.split('=');
                            if (paramArray.length > 1) {
                                if (paramArray[0] === "id") {
                                    itemId = paramArray[1];
                                } else if (paramArray[0] === "quantity") {
                                    quantity = paramArray[1] ? Number(paramArray[1]) : 1;
                                }else if(paramArray[0] === "selling_plan"){
                                    sellingPlan = paramArray[1] ?? null;
                                }
                            } else if (window.tlFreeGiftOffer.utils.isJson(param)) {
                                const paramObj = JSON.parse(param);
                                if(paramObj.id){
                                    itemId =String(paramObj.id);
                                    quantity = paramObj.quantity ? Number(paramObj.quantity) : 1;
                                    sellingPlan = paramObj.selling_plan ?? null;
                                }else if(paramObj.items){
                                    // Fix for theme Beauty has body format {items:[{id,quantity}]}
                                    const firstItem = paramObj.items[0];
                                    let tmpQuantity = 0
                                    paramObj.items.forEach(item => {
                                        if(item.id === firstItem.id){
                                            tmpQuantity += item.quantity ? Number(item.quantity) : 1;
                                        }
                                    });
                                    quantity = tmpQuantity ? tmpQuantity : 1
                                    itemId = String(firstItem.id);
                                    sellingPlan = firstItem.selling_plan ?? null;
                                }
                            }
                        }
                    })
                }
            }

            return { itemId, diffQuantity: quantity, sellingPlan}
        }

        function detectChangeApi(config, cartDataRes){
            let items = JSON.parse(JSON.stringify(cartDataRes.items));

            const bodyArgument = getJsonBodyArgument(config.body)
            let lineChangeIndex = null;
            let newLineQty = Number(bodyArgument.quantity);

            if(bodyArgument.line){
                lineChangeIndex = Number(bodyArgument.line) - 1;
            }else if(bodyArgument.id){
                items.forEach((item, index) => {
                    if(item.key === bodyArgument.id){
                        lineChangeIndex =  index;
                    }
                });
            }else if(bodyArgument.updates) {
                const updates = bodyArgument.updates;
                items.forEach((item, index) => {
                    if(updates[item.key] != null && item.quantity !== Number(updates[item.key])){
                        lineChangeIndex =  index;
                        newLineQty = Number(updates[item.key])
                    }
                    if(Object.keys(updates) &&  Object.keys(updates).length){
                        if(item.id == Object.keys(updates)[0]){
                            lineChangeIndex =  index;                          
                            newLineQty = updates[`${item.id}`]
                        }
                    }
                });

                // Fix for theme has updates body format [{{line_change}}, {{new_qty}}]
                if(lineChangeIndex == null && updates.length == 2){
                    lineChangeIndex = Number(updates[0]);
                    newLineQty = Number(updates[1]);
                }
            }
            return { lineChangeIndex, newLineQty }
        }


        function detectFetchData(resource, config, cartDataRes){
            let data = {
                itemId: null,
                lineChangeKey: null,
                diffQuantity: 1,
                isChangeCartLine: false,
                lineChangeIsGift: false,
                sellingPlan: null,
                preventChangeQuantity: false,
                itemChangeData: null
            }
            if (resource.includes('add')) {
                data = { ...data, ...detectAddApi(config)}
            }else {
                const { lineChangeIndex, newLineQty } = detectChangeApi(config, cartDataRes);
                if(lineChangeIndex !== null){
                    const itemChangeData = cartDataRes.items[lineChangeIndex];
                    const lineChangeIsGift = window.tlFreeGiftOffer.checkLineItemIsGift(itemChangeData);
                    if(lineChangeIsGift && (itemChangeData.price == 0 || itemChangeData.total_discount > 0)){
                        const rule = window.tlFreeGiftOffer.ruleIdMapData.get(lineChangeIsGift);
                        data.preventChangeQuantity = rule && rule.prevent_change_gift_qty
                    }

                    data = {
                        ...data,
                        itemId: String(itemChangeData.id),
                        lineChangeKey: String(itemChangeData.key),
                        diffQuantity: newLineQty > 0 ? (newLineQty - itemChangeData.quantity) : - itemChangeData.quantity,
                        isChangeCartLine: true,
                        lineChangeIsGift, 
                        itemChangeData,
                        sellingPlan: itemChangeData.selling_plan_allocation
                            ? String(itemChangeData.selling_plan_allocation.selling_plan.id)
                            : null
                    }
                }
            }
            return data;
        }

        function fetchOverride() {
            if (!window.fetch || typeof window.fetch !== "function") return;
            const originalFetch = window.fetch;
            window.fetch = async function () {
                const [resource, config] = [...arguments];

                // Shop Pay
                const headers = config?.headers || {};
                const isOtherCreateCart = headers["X-Start-Wallet-Checkout"] === "true" && ["ShopPay", "BuyItNow", "MoreOptions"].includes(headers["X-Wallet-Name"]);
                if(isOtherCreateCart){
                    try {
                        const parsedBody = JSON.parse(config.body);
                        const isCartCreate = parsedBody.query?.includes("mutation cartCreate") && Array.isArray(parsedBody.variables?.input?.lines);

                        if (!isCartCreate) {
                            return originalFetch.apply(this, arguments);
                        }
                        const originalResponse = await originalFetch.apply(this, arguments);
                        const cloneRes = originalResponse.clone();
                        const originalData = await cloneRes.json();

                        const newBody = await processOtherPayGiftRules(originalData, parsedBody);
                        config.body = JSON.stringify(newBody);
                    } catch (error) {
                        console.error("Error injecting gift into OtherPay cartCreate:", error);
                    }
                    return originalFetch.apply(this, arguments);
                }else if (isShopifyCartURL(resource) && config && config.body && config.body !== "{}") {
                    window.tlFreeGiftOffer.cartHasChanged = true;
                    const response = originalFetch.apply(this, arguments)

                    response.then((res) => {
                        res
                            .clone()
                            .json()
                            .then((data) => dispatchEvent(res.url, data));
                    });
                    return response;
                } else {
                    return originalFetch(...arguments)
                }
            };
        }

        ['TLFREEGIFT:add', 'TLFREEGIFT:change', 'TLFREEGIFT:update'].forEach(type => {
            window.addEventListener(type, (event) => {
                window.tlFreeGiftOffer.updateCartData();
            })
        })

        fetchOverride();
        XHROverride();
    }
})();